import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DialogStore } from '@shared/components/ui/dialog/data-access';

export interface CanComponentDeactivate {
  hasUnsavedChanges: () => boolean;
  saveChanges?: () => Promise<boolean> | boolean;
}

/**
 * Guard to prevent navigation when there are unsaved changes.
 */
export const UnsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component): Observable<boolean> | boolean => {

  const dialogStore = inject(DialogStore);
  if (component?.hasUnsavedChanges?.()) {
    return new Observable<boolean>(observer => {
      dialogStore.openDialog({
        title: 'GUARDS.CLOSING_UNSAVED.TITLE',
        message: 'GUARDS.CLOSING_UNSAVED.MESSAGE',
        primaryButton: {
          label: 'GUARDS.CLOSING_UNSAVED.IGNORE',
          action: () => {
            observer.next(true);
            observer.complete();
            dialogStore.closeDialog();
          }
        },
        secondaryButton: {
          label: 'GUARDS.CLOSING_UNSAVED.SAVE',
          action: async () => {
            if (component.saveChanges) {
              const saved = await Promise.resolve(component.saveChanges());
              observer.next(saved);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
            dialogStore.closeDialog();
          }
        }
      })
    });
  }

  return true;
}
